import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolApps = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.29 20.728v-7.275M21 17.09h-7.418M20.258 3v6.548h-6.676V3h6.676ZM9.676 3v6.548H3V3h6.676Zm0 10.38v6.547H3V13.38h6.676Z",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgToolApps;
